var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18.3334H0.5V16.6667C0.5 15.5616 0.960936 14.5018 1.78141 13.7204C2.60188 12.939 3.71468 12.5 4.875 12.5H10.125C11.2853 12.5 12.3981 12.939 13.2186 13.7204C14.0391 14.5018 14.5 15.5616 14.5 16.6667V18.3334ZM7.5 10.8334C6.81056 10.8334 6.12787 10.704 5.49091 10.4528C4.85395 10.2015 4.2752 9.8332 3.78769 9.36891C3.30018 8.90461 2.91347 8.35342 2.64963 7.74679C2.3858 7.14016 2.25 6.48998 2.25 5.83337C2.25 5.17676 2.3858 4.52658 2.64963 3.91996C2.91347 3.31333 3.30018 2.76213 3.78769 2.29784C4.2752 1.83355 4.85395 1.46525 5.49091 1.21398C6.12787 0.962703 6.81056 0.833374 7.5 0.833374C8.89239 0.833374 10.2277 1.36016 11.2123 2.29784C12.1969 3.23552 12.75 4.50729 12.75 5.83337C12.75 7.15946 12.1969 8.43123 11.2123 9.36891C10.2277 10.3066 8.89239 10.8334 7.5 10.8334Z",
    fill: "#737171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.100555f355318cc939c133630cbeb741.svg";
export { ForwardRef as ReactComponent };